import ProjectsFilter from "@/components/filters/projects-filter";
import UsersFilter from "@/components/filters/users-filter";
import useProfile from "@/hooks/use-profile";
import { TFilter } from "@/utilities/types/common";
import { Roles } from "@/utilities/types/Users";
import { PiMagnifyingGlassBold } from "react-icons/pi";
import { Input } from "rizzui";

export interface FilterElementsProps extends TFilter {}

export default function FilterElements({
  filters,
  updateFilter,
  searchTerm,
  onSearch,
}: FilterElementsProps) {
  const { profile } = useProfile();
  const isAdmin = profile?.role === Roles.ADMIN;
  return (
    <div className="flex w-full flex-row flex-wrap items-center justify-between gap-2">
      <div className="flex flex-1  flex-row gap-2 items-center flex-wrap">
        {isAdmin && (
          <UsersFilter
            onChange={(user) => {
              updateFilter("userId", user?.id || "");
            }}
            label="Filter by user"
            value={filters?.userId}
            className="lg:w-[250px] w-full"
          />
        )}

        <ProjectsFilter
          onChange={(project) => {
            updateFilter("projectId", project?.id || "");
          }}
          label="Filter by project"
          value={filters?.projectId}
          className="lg:w-[250px] w-full"
        />
      </div>

      <Input
        type="search"
        placeholder="Search exactly landing page domain"
        value={searchTerm}
        onClear={() => onSearch?.("")}
        onChange={(event) => onSearch?.(event.target.value)}
        prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
        rounded="lg"
        clearable
        label="Search"
        className="mt-auto min-w-[300px] w-full lg:w-[300px]"
      />
    </div>
  );
}
